export const S3_BASE_URL =
  import.meta.env.VITE_S3_BASE_URL ||
  "https://s3stack-pokelands2543037f-lcb4duloycff.s3.sa-east-1.amazonaws.com";
